<template>
    <div :class="colClass" class="mb-5">
        <div class="card">
            <div class="card-header">
                <div class="clearfix d-block">
                    <div class="float-left"><b>AuftragsNr.:</b> {{ getOrderId }}</div>
                    <div class="float-right"><b>Bestellt:</b> {{ order.createdAt|date }}</div>
                </div>
                <div class="clearfix d-block">
                    <div v-if="getExtOrderId" class="float-left"><b>Ext. AuftragsNr:</b> {{ getExtOrderId }}</div>
                    <div class="float-right"><b></b> {{ getRefererName }}</div>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-sm">
                    <thead class="table-light">
                    <tr>
                        <th>Menge</th>
                        <th>ArtikelNr.</th>
                        <th>Bild</th>
                        <th>Titel</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in orderItems" :key="index">
                            <td>{{ item.quantity }}</td>
                            <td>{{ item.itemVariationId }}</td>
                            <td> <img :src="item.image" class="variationimage img-thumbnail" /></td>
                            <td>{{ item.orderItemName }} <br> <small v-if="item.attributeValues"><b>Variante:</b> {{ item.attributeValues }} </small></td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="card-footer">
                <button @click="shippingTracking()" class="float-left btn btn-secondary mr-2 visible-xs-block visible-sm-block">Sendung verfolgen</button>
                <button @click="getInvoiceDocument()" class="float-left  btn btn-secondary visible-xs-block visible-sm-block">Rechnung</button>
                <button @click="$emit('openwizard', order.id)" class="float-right btn btn-warning visible-xs-block visible-sm-block" >Problem melden</button>
            </div>
        </div>

        <div v-if="showShippingStatus" style="display: none">
            <iframe ref="shipping" frameborder="0" width="700" height="500" :src="shippingUrl"></iframe>
        </div>

        <div v-if="showInvoiceModal" style="display: none">
            <object ref="invoice" :data="invoiceUrl" type="application/pdf" style="width:100%;height:485px" view="fit" title="Rechnung">
                <a href="#">PDF laden</a>
            </object>
        </div>

    </div>
</template>

<script>

    export default {
        name: "order-card",

        components: {},

        data: () => ({
            showInvoiceModal: false,
            showShippingStatus: false,
            shippingUrl: String,
            invoiceUrl: false
        }),

        props: {
            order: {
                type: Object,
                required: true
            },

            colsize: {
                type: Number|String,
                default: 4
            }
        },

        methods: {

            getInvoiceDocument () {

                this.$RestClient.getInvoiceDocument( this.order.id )
                    .then(data => {

                        if(data.content){
                            this.invoiceUrl = 'data:application/pdf;base64,' + data.content
                            this.showInvoiceModal = true

                            this.$nextTick(() => {
                                this.$swal({
                                    content: this.$refs.invoice,
                                    className: "shippingModal"
                                })
                                    .then(() => this.showInvoiceModal = false)
                            })

                            return
                        }

                        this.$swal('Leider ist keine Rechnung vorhanden!')
                    })
            },

            shippingTracking () {

                let trackingNumers = this.order.packagenumber.join(',')

                this.shippingUrl = 'https://tracking.dpd.de/status/de_DE/parcel/' + trackingNumers
                this.showShippingStatus = true

                this.$nextTick(() => {
                    this.$swal({
                        content: this.$refs.shipping,
                        className: "shippingModal"
                    })
                        .then(() => {
                            this.shippingUrl = ''
                            this.showShippingStatus = false
                        })
                })

            },
        },

        computed: {
            orderItems () {

                return this.order.orderItems.filter(x => !x.orderItemName.includes('BUNDLE') && x.itemVariationId !== 0)
            },

            getOrderId () {
                return this.order.id
            },

            getExtOrderId () {

                let propertie = this.order.properties.find(x => x.typeId === 7)

                return ( propertie ) ? propertie.value : false
            },

            getRefererName () {

                let refererId = this.order.referrerId.toString()[0]

                switch (refererId){
                    case '1': return 'Webshop'
                    case '2': return 'eBay'
                    case '4': return 'Amazon'
                    case '104': return 'Amazon FBA'
                    default:
                        return 'Bestellung'
                }
            },

            colClass () {
                return 'col-' + this.colsize
            }

        },

        filters: {
            date (value) {
                return value.substr(0,10)
                    .split('-')
                    .reverse()
                    .join('.')
            }
        }
    }
</script>

<style scoped>
    .variationimage{
        width: 60px;
        height: 60px;
        max-width: 75px!important;
        cursor: zoom-in;
        transition: all .2s ease-in-out;
    }
    .variationimage:hover {
        transform: scale(2.5);
    }

    .card-header {
        font-size: 0.95em;
        line-height: 1.8em;
    }

    @media (max-width: 767px) {
        .visible-xs-block, .visible-sm-block {
            padding: 4px;
            font-size: 12px;
        }
    }
</style>

<style>
    .shippingModal { width: 750px }
</style>